import { render, staticRenderFns } from "./baixapagamentos.vue?vue&type=template&id=90453a26&"
import script from "./baixapagamentos.vue?vue&type=script&lang=js&"
export * from "./baixapagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports